<div>
    <rask-action-button (click)="openRegelverk()" icon="far fa-sm fa-external-link">Se regelverk</rask-action-button>
</div>
<div class="selection">
    <rask-selector
        aid="inputHandelssortiment"
        label="Inmätningshandelssortiment"
        class="col-lg-12"
        [reverseLookup]="false"
        placeholder="{{ handelssortimentViewFormatter(beraknatInmatningshandelssortiment) }}"
        [ngModel]="inmatningshandelssortiment"
        (ngModelChange)="onSelectChange($event)"
        [search]="searchForHandelssortiment"
        [viewFormatter]="handelssortimentViewFormatter"
        [raskDisabledControl]="readonly">
    </rask-selector>
</div>
